export enum BUTTON {
  // Danh mục vị trí huấn luyện viên
  VTHLV_XEM = 'VTHLV_XEM',
  VTHLV_SUA = 'VTHLV_SUA',
  VTHLV_XOA = 'VTHLV_XOA',
  VTHLV_THEM = 'VTHLV_THEM',
  // Thiết lập tham số
  TLTS_XEM = 'TLTS_XEM',
  TLTS_SUA = 'TLTS_SUA',
  TLTS_XOA = 'TLTS_XOA',
  TLTS_THEM = 'TLTS_THEM',
  // Nhóm quyền
  NQ_XEM = 'NQ_XEM',
  NQ_SUA = 'NQ_SUA',
  NQ_XOA = 'NQ_XOA',
  NQ_THEM = 'NQ_THEM',
  // Quản lý người dùng
  QLND_XEM = 'QLND_XEM',
  QLND_SUA = 'QLND_SUA',
  QLND_XOA = 'QLND_XOA',
  QLND_THEM = 'QLND_THEM',
  QLND_IMP = 'QLND_IMP',
  QLND_EXP = 'QLND_EXP',
  // Phân quyền dữ liệu
  PQDL_XEM = 'PQDL_XEM',
  PQDL_SUA = 'PQDL_SUA',
  PQDL_XOA = 'PQDL_XOA',
  PQDL_THEM = 'PQDL_THEM',
  // Khám sức khỏe định kỳ
  KSKDK_XEM = 'KSKDK_XEM',
  KSKDK_SUA = 'KSKDK_SUA',
  KSKDK_XOA = 'KSKDK_XOA',
  KSKDK_THEM = 'KSKDK_THEM',
  KSKDK_EXP = 'KSKDK_EXP',
  KSKDK_MLKK = 'KSKDK_MLKK',
  // Quản lý chấn thương
  QLCTH_XEM = 'QLCTH_XEM',
  QLCTH_SUA = 'QLCTH_SUA',
  QLCTH_XOA = 'QLCTH_XOA',
  QLCTH_THEM = 'QLCTH_THEM',
  // Quản lý trận đấu
  QLTD_XEM = 'QLTD_XEM',
  QLTD_SUA = 'QLTD_SUA',
  QLTD_XOA = 'QLTD_XOA',
  QLTD_THEM = 'QLTD_THEM',
  // Quản lý khen thưởng
  QLKT_XEM = 'QLKT_XEM',
  QLKT_SUA = 'QLKT_SUA',
  QLKT_XOA = 'QLKT_XOA',
  QLKT_THEM = 'QLKT_THEM',
  QLKT_EXP = 'QLKT_EXP',
  // Quản lý kỷ luật
  QLKL_XEM = 'QLKL_XEM',
  QLKL_SUA = 'QLKL_SUA',
  QLKL_XOA = 'QLKL_XOA',
  QLKL_EXP = 'QLKL_EXP',
  QLKL_THEM = 'QLKL_THEM',
  // Danh sách tiếp nhận
  DSTNCT_XEM = 'DSTNCT_XEM',
  DSTNCT_SUA = 'DSTNCT_SUA',
  DSTNCT_XOA = 'DSTNCT_XOA',
  DSTNCT_THEM = 'DSTNCT_THEM',
  DSTNCT_IMP = 'DSTNCT_IMP',
  DSTNCT_EXP = 'DSTNCT_EXP',
  // Quản lý cầu thủ
  QLCT_XEM = 'QLCT_XEM',
  QLCT_SUA = 'QLCT_SUA',
  QLCT_THEM_ACC = 'QLCT_THEM_ACC',
  QLCT_CHO_MUON = 'QLCT_CHO_MUON',
  QLCT_LUAN_CHUYEN = 'QLCT_LUAN_CHUYEN',
  QLCT_THANH_LY = 'QLCT_THANH_LY',
  QLCT_CHAN_THUONG = 'QLCT_CHAN_THUONG',
  QLCT_CHUYEN_NHUONG = 'QLCT_CHUYEN_NHUONG',
  QLCT_KICH_HOAT = 'QLCT_KICH_HOAT',
  QLCT_IMP = 'QLCT_IMP',
  QLCT_EXP = 'QLCT_EXP',
  QLCT_THEM = 'QLCT_THEM',
  // Quản lý huấn luyện viên
  QLHLV_XEM = 'QLHLV_XEM',
  QLHLV_SUA = 'QLHLV_SUA',
  QLHLV_THEM = 'QLHLV_THEM',
  QLHLV_THEM_ACC = 'QLHLV_THEM_ACC',
  QLHLV_IMP = 'QLHLV_IMP',
  QLHLV_EXP = 'QLHLV_EXP',
  // Quản lý điểm học văn hóa
  QLDHVH_XEM = 'QLDHVH_XEM',
  QLDHVH_SUA = 'QLDHVH_SUA',
  QLDHVH_XOA = 'QLDHVH_XOA',
  QLDHVH_IMP = 'QLDHVH_IMP',
  QLDHVH_EXP = 'QLDHVH_EXP',
  QLDHVH_COP = 'QLDHVH_COP',
  // Quản lý mục tiêu
  QLMT_XEM = 'QLMT_XEM',
  QLMT_SUA = 'QLMT_SUA',
  QLMT_XOA = 'QLMT_XOA',
  QLMT_THEM = 'QLMT_THEM',
  // Quản lý kỳ sát hạch
  QLKSH_XEM = 'QLKSH_XEM',
  QLKSH_SUA = 'QLKSH_SUA',
  QLKSH_XOA = 'QLKSH_XOA',
  QLKSH_IMP = 'QLKSH_IMP',
  QLKSH_EXP = 'QLKSH_EXP',
  QLKSH_THEM = 'QLKSH_THEM',
  // Quản lý đào tạo lớp chuyên môn
  QLDTCM_XEM = 'QLDTCM_XEM',
  QLDTCM_SUA = 'QLDTCM_SUA',
  QLDTCM_XOA = 'QLDTCM_XOA',
  QLDTCM_THEM = 'QLDTCM_THEM',
  // Tổng hợp điểm danh
  THDD_XEM = 'THDD_XEM',
  THDD_SUA = 'THDD_SUA',
  THDD_EXP = 'THDD_EXP',
  // Danh mục bài học
  DMBH_XEM = 'DMBH_XEM',
  DMBH_SUA = 'DMBH_SUA',
  DMBH_XOA = 'DMBH_XOA',
  DMBH_THEM = 'DMBH_THEM',
  // Danh mục bộ chỉ số
  DMBCS_XEM = 'DMBCS_XEM',
  DMBCS_SUA = 'DMBCS_SUA',
  DMBCS_XOA = 'DMBCS_XOA',
  DMBCS_THEM = 'DMBCS_THEM',
  // Danh mục chương trình văn hóa
  DMCTVH_XEM = 'DMCTVH_XEM',
  DMCTVH_SUA = 'DMCTVH_SUA',
  DMCTVH_XOA = 'DMCTVH_XOA',
  DMCTVH_THEM = 'DMCTVH_THEM',
  // Danh mục kế hoạch tuần
  DMKHT_XEM = 'DMKHT_XEM',
  DMKHT_SUA = 'DMKHT_SUA',
  DMKHT_XOA = 'DMKHT_XOA',
  DMKHT_THEM = 'DMKHT_THEM',
  // Danh mục câu lạc bộ
  DMCLB_XEM = 'DMCLB_XEM',
  DMCLB_SUA = 'DMCLB_SUA',
  DMCLB_XOA = 'DMCLB_XOA',
  DMCLB_THEM = 'DMCLB_THEM',
  // Quản lý đội bóng
  QLDB_XEM = 'QLDB_XEM',
  QLDB_SUA = 'QLDB_SUA',
  QLDB_XOA = 'QLDB_XOA',
  QLDB_THEM = 'QLDB_THEM',
  // Danh mục năm học
  DMNH_XEM = 'DMNH_XEM',
  DMNH_SUA = 'DMNH_SUA',
  DMNH_XOA = 'DMNH_XOA',
  DMNH_THEM = 'DMNH_THEM',
  // Danh mục giải đấu
  DMGD_XEM = 'DMGD_XEM',
  DMGD_SUA = 'DMGD_SUA',
  DMGD_XOA = 'DMGD_XOA',
  DMGD_THEM = 'DMGD_THEM',
  // Danh mục vị trí cầu thủ trên sân
  DMVTCTTS_XEM = 'DMVTCTTS_XEM',
  DMVTCTTS_SUA = 'DMVTCTTS_SUA',
  DMVTCTTS_XOA = 'DMVTCTTS_XOA',
  DMVTCTTS_THEM = 'DMVTCTTS_THEM',
  // Danh mục chỉ số đánh giá
  DMCSDG_XEM = 'DMCSDG_XEM',
  DMCSDG_SUA = 'DMCSDG_SUA',
  DMCSDG_XOA = 'DMCSDG_XOA',
  DMCSDG_THEM = 'DMCSDG_THEM',
  // Danh mục giải thưởng
  DMGT_XEM = 'DMGT_XEM',
  DMGT_SUA = 'DMGT_SUA',
  DMGT_XOA = 'DMGT_XOA',
  DMGT_THEM = 'DMGT_THEM',
  // Danh mục nhóm chỉ số đánh giá
  DMNCSDG_XEM = 'DMNCSDG_XEM',
  DMNCSDG_SUA = 'DMNCSDG_SUA',
  DMNCSDG_XOA = 'DMNCSDG_XOA',
  DMNCSDG_THEM = 'DMNCSDG_THEM',

  // Danh mục phòng ban
  DMPB_XEM = 'DMPB_XEM',
  DMPB_SUA = 'DMPB_SUA',
  DMPB_XOA = 'DMPB_XOA',
  DMPB_THEM = 'DMPB_THEM',

  DASHBOARD = 'Dashboard',
  QLND_RESET_PASSWORD = 'QLND_RESET_PASSWORD',

  // quản lý bệnh án
  QLBA_XEM = 'QLBA_XEM',
  QLBA_SUA = 'QLBA_SUA',
  QLBA_XOA = 'QLBA_XOA',
  QLBA_THEM = 'QLBA_THEM',
}
